Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBoxShadows = void 0;
var _reactNative = require("react-native-web");
var _useColors2 = require("./useColors");
var _getREM = require("../../getREM");
var _getOpaqueColor = require("../../getOpaqueColor");
var useBoxShadows = exports.useBoxShadows = function useBoxShadows() {
  var _useColors = (0, _useColors2.useColors)(),
    colors = _useColors.colors;
  var _shadows = {};
  _shadows.box = {
    color: colors.shadow,
    opacity: 0.2,
    elevation: 4,
    offset: {
      width: 0,
      height: (0, _getREM.getREM)(0.25)
    },
    radius: (0, _getREM.getREM)(0.25)
  };
  _shadows.box_pointerOver = Object.assign({}, _shadows.box, {
    opacity: 0.4,
    elevation: 6
  });
  _shadows.card = {
    color: colors.shadow,
    opacity: 0.2,
    elevation: 4,
    offset: {
      width: 0,
      height: 0
    },
    radius: (0, _getREM.getREM)(0.5)
  };
  _shadows.card_pointerOver = Object.assign({}, _shadows.card, {
    opacity: 0.4,
    elevation: 6
  });
  _shadows.button = {
    color: colors.shadow,
    opacity: 0.2,
    elevation: 4,
    offset: {
      width: 0,
      height: (0, _getREM.getREM)(0.1875)
    },
    radius: (0, _getREM.getREM)(0.125)
  };
  _shadows.button_pointerOver = Object.assign({}, _shadows.button, {
    opacity: 0.4,
    elevation: 6
  });
  var boxShadows = {};
  Object.keys(_shadows).forEach(function (key) {
    var _shadow = _shadows[key];
    if (!_shadow) return;
    boxShadows[key] = {};
    boxShadows[key].web = Object.assign({}, _reactNative.Platform.select({
      web: {
        boxShadow: "".concat(_shadow.offset.width, " ").concat(_shadow.offset.height, " ").concat(_shadow.radius, " ").concat((0, _getOpaqueColor.getOpaqueColor)(_shadow.color, _shadow.opacity)),
        transition: 'box-shadow 0.2s ease-out'
      }
    }));
    boxShadows[key].android = Object.assign({}, _reactNative.Platform.select({
      android: {
        elevation: _shadow.elevation,
        shadowColor: _shadow.color
      }
    }));
    boxShadows[key].ios = Object.assign({}, _reactNative.Platform.select({
      ios: {
        shadowOpacity: _shadow.opacity,
        shadowRadius: _shadow.radius / 1.5,
        shadowOffset: _shadow.offset,
        shadowColor: _shadow.color
      }
    }));
    boxShadows[key].all = Object.assign({}, boxShadows[key].web, boxShadows[key].android, boxShadows[key].ios);
  });
  boxShadows.none = Object.assign({}, _reactNative.Platform.select({
    web: {
      boxShadow: 'none'
    },
    android: {
      elevation: 0,
      shadowColor: undefined
    },
    ios: {
      shadowOpacity: 0,
      shadowRadius: undefined,
      shadowOffset: undefined,
      shadowColor: undefined
    }
  }));
  return {
    boxShadows: boxShadows,
    boxShadowsRaw: _shadows
  };
};